export type UserDisplayNameInput = {
  first_name?: string | null;
  last_name?: string | null;
  full_name?: string | null;
  emails?: ReadonlyArray<{ email?: string | null }> | null;
  id?: string | null;
};

/**
 * Formats the user label shared by documents, action responses, and CRM UI.
 * Names take precedence over full names, then an email local part, then an id.
 */
export const getUserDisplayName = (
  user: UserDisplayNameInput,
  {
    fallbackToId = true,
    trimCombinedName = true,
  }: { fallbackToId?: boolean; trimCombinedName?: boolean } = {},
): string => {
  const combinedName = `${user.first_name?.trim() ?? ''} ${
    user.last_name?.trim() ?? ''
  }`;
  const name = trimCombinedName ? combinedName.trim() : combinedName;
  const emailName = user.emails?.[0]?.email
    ?.split('@')[0]
    ?.replace(/\d/g, '')
    .replace(/[._]/g, ' ')
    .trim();
  return (
    [
      name,
      user.full_name?.trim() ?? '',
      emailName ?? '',
      fallbackToId ? user.id ?? '' : '',
    ].find(value => value.replace(' ', '') !== '') ?? ''
  );
};
